const initialState = {
  // Getting Invoices List
  isGettingInvoicesList: false,
  invoicesList: [],

  // is Adding Invoices
  isAddingInvoicesList: false,

  // is Updating Invoices
  isUpdatingInvoicesList: false,

  // is Deleting HS Invoices
  isDeletingInvoicesList: false,

  // get Transection Type
  isGettingTransactionType: false,
  transactionType: [],

  // Getting Invoice Summary 
  isGettingInvoiceSummary: false,
  invoiceSummary: {},

  // Getting Transection Rate with ID
  isGettingRateWithTransactionIdList: false,
  rateList: [],

  // Getting SRO with Rate ID
  isGettingSroWithRateIdList: false,
  sroList: [],

  // Getting SRO Items with SRO ID
  isGettingSroItemsWithSroIdList: false,
  sroItemsList: [],

  // Uploading Bulk Invoice
  isUploadingBulkInvoice: false,

  // Getting Transaction Type Acc to Company Id
  isGettingTransactionTypeAccToComId: false,
  transectionTypeListAccToCompanyId: [],

  // Getting Invoice History
  isGettingInvoiceHistory: false,
  invoiceHistory: [],

  // Cancelling Invoice Status
  isCancellingInvoiceStatus: false,

  // Toggling Invoice Visibility
  isTogglingInvoiceVisibility: false,
};

const InvoicesListReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting Invoices List
    case "INVOICES_LIST_REQUEST":
      return {
        ...state,
        isGettingInvoicesList: true,
      };
    case "INVOICES_LIST_SUCCESS":
      return {
        ...state,
        invoicesList: action.payload?.data,
        page: action.payload?.page,
        totalResults: action.payload?.totalResults,
        isGettingInvoicesList: false,
      };
    case "INVOICES_LIST_ERROR":
      return {
        ...state,
        isGettingInvoicesList: false,
      };
    // Editing Invoices List
    case "ADD_INVOICES_REQUEST":
      return {
        ...state,
        isAddingInvoicesList: true,
      };
    case "ADD_INVOICES_SUCCESS":
      return {
        ...state,
        isAddingInvoicesList: false,
      };
    case "ADD_INVOICES_ERROR":
      return {
        ...state,
        isAddingInvoicesList: false,
      };
    // Updateing Invoices List
    case "UPDATE_INVOICES_LIST_REQUEST":
      return {
        ...state,
        isUpdatingInvoicesList: true,
      };
    case "UPDATE_INVOICES_LIST_SUCCESS":
      return {
        ...state,
        isUpdatingInvoicesList: false,
      };
    case "UPDATE_INVOICES_LIST_ERROR":
      return {
        ...state,
        isUpdatingInvoicesList: false,
      };
    // Deleting Invoices List
    case "DELETE_INVOICES_LIST_REQUEST":
      return {
        ...state,
        isDeletingInvoicesList: true,
      };
    case "DELETE_INVOICES_LIST_SUCCESS":
      return {
        ...state,
        isDeletingInvoicesList: false,
      };
    case "DELETE_INVOICES_LIST_ERROR":
      return {
        ...state,
        isDeletingInvoicesList: false,
      };
    // getting Transection List
    case "TRANSACTION_LIST_REQUEST":
      return {
        ...state,
        isGettingTransactionType: true,
      };
    case "TRANSACTION_LIST_SUCCESS":
      return {
        ...state,
        transactionType: action.payload?.data,
        isGettingTransactionType: false,
      };
    case "TRANSACTION_LIST_ERROR":
      return {
        ...state,
        isGettingTransactionType: false,
      };
    // Sending Invoice To FBR
    case "SEND_INVOICE_TO_FBR_LIST_REQUEST":
      return {
        ...state,
        isGettingInvoicesList: true,
      };
    case "SEND_INVOICE_TO_FBR_LIST_SUCCESS":
      return {
        ...state,
        isGettingInvoicesList: false,
      };
    case "SEND_INVOICE_TO_FBR_LIST_ERROR":
      return {
        ...state,
        isGettingInvoicesList: false,
      };
    // Getting Invoice Summary
    case "INVOICE_SUMMARY_LIST_REQUEST":
      return {
        ...state,
        isGettingInvoiceSummary: true,
      };
    case "INVOICE_SUMMARY_LIST_SUCCESS":
      return {
        ...state,
        invoiceSummary: action.payload,
        isGettingInvoiceSummary: false,
      };
    case "INVOICE_SUMMARY_LIST_ERROR":
      return {
        ...state,
        isGettingInvoiceSummary: false,
      };
    // Get Transaction Rate with ID
    case "GET_RATE_WITH_TRANSACTION_ID_REQUEST":
      return {
        ...state,
        isGettingRateWithTransactionIdList: true,
      };
    case "GET_RATE_WITH_TRANSACTION_ID_SUCCESS":
      return {
        ...state,
        rateList: action.payload?.data,
        isGettingRateWithTransactionIdList: false,
      };
    case "GET_RATE_WITH_TRANSACTION_ID_ERROR":
      return {
        ...state,
        isGettingRateWithTransactionIdList: false,
      };
    // Get SRO with Rate ID
    case "GET_SRO_WITH_RATE_ID_REQUEST":
      return {
        ...state,
        isGettingSroWithRateIdList: true,
      };
    case "GET_SRO_WITH_RATE_ID_SUCCESS":
      return {
        ...state,
        sroList: action.payload?.data,
        isGettingSroWithRateIdList: false,
      };
    case "GET_SRO_WITH_RATE_ID_ERROR":
      return {
        ...state,
        isGettingSroWithRateIdList: false,
      };
    // Get SRO Items with SRO ID
    case "GET_SRO_ITEMS_WITH_SRO_ID_REQUEST":
      return {
        ...state,
        isGettingSroItemsWithSroIdList: true,
      };
    case "GET_SRO_ITEMS_WITH_SRO_ID_SUCCESS":
      return {
        ...state,
        sroItemsList: action.payload?.data,
        isGettingSroItemsWithSroIdList: false,
      };
    case "GET_SRO_ITEMS_WITH_SRO_ID_ERROR":
      return {
        ...state,
        isGettingSroItemsWithSroIdList: false,
      };
    // Get SRO Items with SRO ID
    case "UPLOAD_BULK_INVOICE_REQUEST":
      return {
        ...state,
        isUploadingBulkInvoice: true,
      };
    case "UPLOAD_BULK_INVOICE_SUCCESS":
      return {
        ...state,
        isUploadingBulkInvoice: false,
      };
    case "UPLOAD_BULK_INVOICE_ERROR":
      return {
        ...state,
        isUploadingBulkInvoice: false,
      };
    // Geting Transaction Type Acc to Company ID
    case "TRANSACTION_LIST_WITH_COMPANY_ID_REQUEST":
      return {
        ...state,
        isGettingTransactionTypeAccToComId: true,
      };
    case "TRANSACTION_LIST_WITH_COMPANY_ID_SUCCESS":
      return {
        ...state,
        isGettingTransactionTypeAccToComId: false,
        transectionTypeListAccToCompanyId: action?.payload?.data,
      };
    case "TRANSACTION_LIST_WITH_COMPANY_ID_ERROR":
      return {
        ...state,
        isGettingTransactionTypeAccToComId: false,
      };
    // Cancelling Invoice Status
    case "CANCEL_INVOICE_STATUS_REQUEST":
      return {
        ...state,
        isCancellingInvoiceStatus: true,
      };
    case "CANCEL_INVOICE_STATUS_SUCCESS":
      return {
        ...state,
        isCancellingInvoiceStatus: false,
      };
    case "CANCEL_INVOICE_STATUS_ERROR":
      return {
        ...state,
        isCancellingInvoiceStatus: false,
      };
    // Toggling Invoice Visibility
    case "TOGGLE_INVOICE_VISIBILITY_REQUEST":
      return { ...state, isTogglingInvoiceVisibility: true };
    case "TOGGLE_INVOICE_VISIBILITY_SUCCESS":
      return { ...state, isTogglingInvoiceVisibility: false };
    case "TOGGLE_INVOICE_VISIBILITY_ERROR":
      return { ...state, isTogglingInvoiceVisibility: false };
    // Getting Invoice History
    case "GET_INVOICE_HISTORY_REQUEST":
      return {
        ...state,
        isGettingInvoiceHistory: true,
        invoiceHistory: [],
      };
    case "GET_INVOICE_HISTORY_SUCCESS":
      return {
        ...state,
        isGettingInvoiceHistory: false,
        invoiceHistory: action.payload?.data || action.payload || [],
      };
    case "GET_INVOICE_HISTORY_ERROR":
      return {
        ...state,
        isGettingInvoiceHistory: false,
        invoiceHistory: [],
      };
    default:
      return state;
  }
};

export default InvoicesListReducer;
